// components/LoginForm.jsx
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../theme/orb-theme.css";
import { Panel, Button } from "../theme/OrbUI";

export default function LoginForm() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    const vesselId = sessionStorage.getItem("selectedVesselId");
    if (!vesselId || vesselId === "null" || vesselId === "undefined") {
      setError("Vessel not selected. Please go back and select a vessel.");
      return;
    }

    try {
      const response = await fetch("/api/login/", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password, vessel_id: vesselId }),
        credentials: 'include' 
      });

      const data = await response.json();
      if (response.ok) {
        sessionStorage.setItem("currentUser", JSON.stringify(data.user));
        sessionStorage.setItem("authToken", data.token);
        const rankId = parseInt(data.user.RankId, 10);
        if ([0, 2, 8].includes(rankId)) {
          navigate("/chief-dashboard");
        } else {
          navigate("/crew-dashboard");
        }
      } else {
        setError(data.error || "Invalid credentials");
      }
    } catch (err) {
      console.error("Login error:", err);
      setError("Network error. Is Django running?");
    }
  };

  return (
    <div className="orb-theme login-page">
      <Panel title="Login">
        <h2>Login to ORB System</h2>
        <p className="help">Enter your username and password</p>

        {error && <p className="error">{error}</p>}

        <form onSubmit={handleSubmit} className="stack" style={{ maxWidth: "100%" }}>
          <div className="field">
            <input
              type="text"
              placeholder="Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>

          <div className="field">
            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <Button glow type="submit">
              Login
            </Button>
          </div>
        </form>
      </Panel>
    </div>
  );
}
